module.exports = __webpack_public_path__ + "static/fonts/Helvetica-Regular.0dbdd78.eot";